// TODO should be TS builtin behavior
// Only for TypeScript narrowing of command type
export const stringStartsWith = (str, search) => str.startsWith(search);
export const stringEndsWith = (str, search) => str.endsWith(search);
export const stringIncludes = (str, search) => str.includes(search);
